import { useEffect, useState } from 'react';
import SegmentApi from '../../service/api/Segment';
import useTree from './useTree';
const useSegment = (axios, campaign, value) => {
    const [treeData, setTreeData] = useState(null);
    const [tree, checkedIds] = useTree(treeData, value.segmentIds);
    useEffect(() => {
        if (!value.locationIds.length) {
            setTreeData(null);
            return;
        }
        (async () => {
            try {
                const segmentApi = new SegmentApi(axios, campaign);
                setTreeData((await segmentApi.get({
                    locationIds: value.locationIds.filter(location => location !== '*')
                })).toObject());
            }
            catch (exception) {
                setTreeData(null);
                console.warn('Failed to retrieve tree data for filter. Exception: ' + exception);
            }
        })();
    }, [axios, campaign, value.locationIds]);
    return [tree, checkedIds];
};
export default useSegment;
